const STRIPE_SCRIPT_URL = 'https://js.stripe.com/v3/'

let pendingLoad = null

export const loadStripeScript = () => {
  if (window.Stripe) return Promise.resolve()
  if (pendingLoad) return pendingLoad
  pendingLoad = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = STRIPE_SCRIPT_URL
    script.onload = () => resolve()
    script.onerror = () => {
      pendingLoad = null
      reject(new Error('Stripe script failed to load'))
    }
    document.head.appendChild(script)
  })
  return pendingLoad
}
